import React from 'react';
import { ReleasePage } from './ReleasePage';

export const OmniReleaseVersion = () => {
    return (
        <ReleasePage 
            title="Omnichannel - Release Versions"
            jsonUrl="/releases_omnichannel.json"
            mainReleaseType={["Long Term Support"]}
            subReleaseType="Service Pack"
        />
    );
}

export default OmniReleaseVersion;